import { useEffect, useState, useMemo } from 'react'
import { useLocation, useNavigate } from "react-router-dom"
import { Table } from 'antd'

import { getObjectSearchParams, getDataQueryString } from 'utils/urls'
import TableRawActions from './TableRawActions'
import TableFooter from './TableFooter'

import './styles.css'


function getOrder(field, orderField) {
  if (orderField === field) return 'ascend';
  if (orderField === `-${field}`) return 'descend';
  return false;
}

function getOrderField(field, order) {
  if (order === 'ascend') return field;
  if (order === 'descend') return `-${field}`;
  return false;
}


const TableList = ({
  queryKey,
  rowKey,
  params,
  filterParams,
  fields,
  columnList,
  dataList,

  apiGetList,
  apiGetListProps,
  apiBatchDelete,
  apiUpdateProps,
  apiDeleteProps,
  apiBatchDeleteProps,
  apiBatchUpdateProps,

  rowActions,
  rowSelection,
  hidePagination,
  expandable,
  sticky,
}) => {
  if ((dataList === null || dataList === undefined) && (!apiGetList && !apiGetListProps)) {
    throw new Error('Parameters dataList or apiGetList/apiGetListProps are required!');
  }

  const location = useLocation();
  const navigate = useNavigate();

  const [selected, setSelected] = useState([]);

  const searchParams = new URLSearchParams(location.search);

  const objectSearchParams = useMemo(() => {
    return getObjectSearchParams(location.search, queryKey);
  }, [location.search, queryKey]);

  const orderField = objectSearchParams.get('ordering');

  const columns = useMemo(() => {
    return columnList.reduce((result, fieldName) => {
      let config = fields[fieldName];
      if (config) {
        result.push({ ...config, key: fieldName, dataIndex: fieldName, sortOrder: getOrder(fieldName, orderField) })
      }
      return result
    }, []);
  }, [columnList, fields, orderField]);

  const onBatchDelete = (selected) => {
    apiBatchDelete && apiBatchDelete(selected);
    setSelected([]);
  }

  function loadData(changeNav = true) {
    const [dataQueryString, searchString] = getDataQueryString(searchParams, objectSearchParams, queryKey);
    if (changeNav) navigate({ search: searchString }, { replace: true });

    apiGetList && apiGetList({ params: dataQueryString, filterParams });
  }

  const onTableChange = (pagination, filters, sorter) => {
    const ordering = getOrderField(sorter.field, sorter.order);
    if (ordering) {
      objectSearchParams.set('ordering', getOrderField(sorter.field, sorter.order));
    } else {
      objectSearchParams.delete('ordering');
    }

    const offset = (pagination.current - 1) * pagination.pageSize;
    if (offset) {
      objectSearchParams.set('offset', offset);
    } else {
      objectSearchParams.delete('offset');
    }

    loadData();
  };

  const onPagination = (page, pageSize) => {
    const offset = (page - 1) * pageSize;
    if (offset) {
      objectSearchParams.set('offset', offset);
    } else {
      objectSearchParams.delete('offset');
    }

    loadData();
  };

  useEffect(() => {
    loadData(false);
    // eslint-disable-next-line
  }, []);

  //const params = filterParams ? Object.keys(filterParams).map(k => filterParams[k]) : [];

  useEffect(() => {
    loadData(false);
    // eslint-disable-next-line
  }, [params, filterParams]);

  useEffect(() => {
    if (apiUpdateProps?.isSuccess || apiDeleteProps?.isSuccess || apiBatchDeleteProps?.isSuccess || apiBatchUpdateProps?.isSuccess) {
      loadData();
    }
    // eslint-disable-next-line
  }, [apiUpdateProps?.isSuccess, apiDeleteProps?.isSuccess, apiBatchDeleteProps?.isSuccess || apiBatchUpdateProps?.isSuccess]);

  const _rowActions = rowActions || [{
    title: 'Удалить',
    icon: 'delete',
    type: 'danger',
    action: (selected) => onBatchDelete(selected),
    confirm: true,
  }];

  const dataSource = dataList ? dataList : apiGetListProps.data?.results || [];
  const count = dataList ? dataList.length : apiGetListProps.data?.count || 0;

  return (
    <div className="tableList">
      <TableRawActions
        rowActions={_rowActions}
        selected={selected}
        clearSelected={() => setSelected([])}
      />

      <Table
        tableLayout="auto"
        sticky={sticky}
        columns={columns}
        dataSource={dataSource}
        rowKey={rowKey || "id"}
        loading={apiGetListProps?.isFetching}
        pagination={false}
        onChange={onTableChange}
        expandable={expandable}

        rowSelection={rowSelection && {
          selectedRowKeys: selected,
          onChange: (selectedRowKeys, selectedRows) => {
            setSelected(selectedRowKeys.slice());
          },
        }}
      />

      {!hidePagination &&
        <TableFooter objectSearchParams={objectSearchParams} allCount={count} onChange={onPagination} />}
    </div>
  );
};


export default TableList;
